import { getCookie, type OptionsType, setCookie } from 'cookies-next'

export const saveTrackingConsent = (consent: boolean) =>
  setCookie('tracking_consent', consent, {
    maxAge: 31536000,
  })

export const getTrackingConsent = async (options?: OptionsType) => {
  const consent = await getCookie('tracking_consent', options)

  if (!consent) return undefined
  return consent === 'true'
}
